import { TrackingContext } from '@change-corgi/core/react/tracking';
import { Link } from '@change-corgi/design-system/components/actions';
import { Box, Flex } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import { CommentDelete, CommentLikes, CommentReportAbuse, CommentShares } from 'src/app/shared/components/comments';
import { Join } from 'src/app/shared/components/layout/misc';

import { useCommentFooter } from './hooks/useCommentFooter';

export function CommentFooter() {
	const {
		data: { author, authorUrl, dateRelative, location, canReport, canDelete, comment, petition, trackingProperties },
		actions: { handleDeletedComment },
	} = useCommentFooter();

	return (
		<Box>
			<Flex sx={{ gap: 16 }} mb={16}>
				<Text size="caption" sx={{ flex: 1 }} data-qa="comment-author">
					{authorUrl ? <Link to={authorUrl}>{author}</Link> : author}, {location}
				</Text>
				<Text size="caption" sx={{ whiteSpace: 'nowrap' }} data-qa="comment-date">
					{dateRelative}
				</Text>
			</Flex>
			<Flex sx={{ gap: 16, justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
				<Flex sx={{ gap: 16, alignItems: 'center' }}>
					<TrackingContext properties={trackingProperties}>
						<CommentLikes comment={comment} />
					</TrackingContext>
					<CommentShares comment={comment} petition={petition} viewContext="petitions_comments_show" />
				</Flex>
				<Flex sx={{ alignItems: 'center' }}>
					<Join
						separator={
							<Text color="neutral-grey600" mx={8}>
								·
							</Text>
						}
					>
						{canDelete && (
							<TrackingContext properties={trackingProperties}>
								<CommentDelete
									size="large"
									color="neutral-grey600"
									comment={comment}
									onDeleted={handleDeletedComment}
								/>
							</TrackingContext>
						)}
						{canReport && <CommentReportAbuse size="caption" comment={comment} petition={petition} />}
					</Join>
				</Flex>
			</Flex>
		</Box>
	);
}
